import { useProjectModifyViewStore } from '@/features/Project';
import { type TaskSetAutoSuggestSelectItem } from '@/features/TaskBundle';
import { getUniqueId } from '@/utils/misc';
import { type TaskSetItem } from '../../types';

export const emptyTaskBundle = (): TaskSetItem => {
	return {
		id: '',
		name: '',
		taskTemplatesCount: 0,
		maxDays: undefined,
		minDays: undefined,
		ordering: 0,
		uuid: getUniqueId(),
	};
};

export const shouldHideStartDateColumn = () => {
	const projectsViewStore = useProjectModifyViewStore(); // Test fail if initialized outside the function

	return (
		!!projectsViewStore.isTemplate &&
		!!projectsViewStore.hasBackToBackPhases
	);
};

export const getTaskSetFromAutoSuggestItem = (
	bundle: TaskSetAutoSuggestSelectItem | null,
	bundleRow: TaskSetItem
) => {
	return bundle
		? {
				uuid: bundleRow.uuid,
				ordering: bundleRow.ordering,
				id: `${bundle.id}`,
				name: bundle.details?.title || '',
				taskTemplatesCount: bundle.details?.taskTemplatesCount || 0,
				minDays: bundle.details?.minDays,
				maxDays: bundle.details?.maxDays,
			}
		: {
				...emptyTaskBundle(),
				uuid: bundleRow.uuid,
			};
};
